import React, { FC } from 'react';
import styled from 'styled-components';
import { colors } from 'src/config/colors';
import LiveStreamingIcon from 'src/assets/icons/LiveStreamingIcon';
import { StyleProps } from 'src/lib/styleProps';
import { AvailabilityStatus, CourseEvent } from 'src/common/models/event';
import CheckIcon from 'src/assets/icons/CheckIcon';
import UserPlusIcon from 'src/assets/icons/UserPlusIcon';
import LockIcon from 'src/assets/icons/LockIcon';

const Status = styled.div`
  align-items: flex-start;
  display: flex;
  white-space: normal;
  text-align: left;

  svg {
    margin-top: 0.1875rem;
    margin-right: 0.625rem;
    flex-shrink: 0;
  }
`;

export interface CourseEventStatusLabelProps extends StyleProps {
  courseEvent: CourseEvent;
}

export const CourseEventStatusLabel: FC<CourseEventStatusLabelProps> = ({
  className,
  style,
  courseEvent,
}) => (
  <Status className={className} style={style}>
    {courseEvent.webinarJoinUrl == null && (
      <>
        {(courseEvent.availabilityStatus === AvailabilityStatus.Available ||
          courseEvent.availabilityStatus === AvailabilityStatus.OtherEvent) && (
          <>
            <UserPlusIcon size={12} />
            <span>Zapisz się</span>
          </>
        )}
        {courseEvent.availabilityStatus === AvailabilityStatus.Pending && (
          <>
            <CheckIcon size={12} />
            <span>Zgłosiłeś się</span>
          </>
        )}
        {courseEvent.availabilityStatus === AvailabilityStatus.Accepted && (
          <>
            <CheckIcon size={12} />
            <span>Zapisałeś się</span>
          </>
        )}
        {courseEvent.availabilityStatus === AvailabilityStatus.NotAvailable && (
          <>
            <LockIcon size={12} />
            <span>Nabór zakończony</span>
          </>
        )}
        {courseEvent.availabilityStatus === AvailabilityStatus.Full && (
          <>
            <LockIcon size={12} />
            <span>Nabór zakończony</span>
          </>
        )}
        {courseEvent.availabilityStatus === AvailabilityStatus.Trainer && (
          <>
            <CheckIcon size={12} />
            <span style={{ fontSize: '75%' }}>Jesteś zapisany jako wykładowca</span>
          </>
        )}
      </>
    )}

    {courseEvent.webinarJoinUrl != null && (
      <>
        <LiveStreamingIcon size={12} style={{ color: colors.red }} />
        <span>W trakcie</span>
      </>
    )}
  </Status>
);
